export const generateAnswer = async ({ question, context }) => {
  const messages = context
    ? [
        {
          role: "system",
          content:
            "You are an HR assistant for BizBrolly. Answer ONLY from the policy text below. " +
            "Do NOT use general knowledge. Include exact numbers, days, and rules as stated. " +
            "Use bullet points or numbered lists when policy has list items. " +
            "If not found in policy, say: 'This is not covered in the available policy documents.'"
        },
        {
          role: "user",
          content: `POLICY CONTEXT:\n${context}\n\nQUESTION:\n${question}`
        }
      ]
    : [
        {
          role: "system",
          content:
            "You are an HR assistant for BizBrolly. No policy data was found. " +
            "Tell the user you could not find relevant policy info and suggest contacting HR."
        },
        {
          role: "user",
          content: question
        }
      ];

  const res = await fetch("https://api.openai.com/v1/chat/completions", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      model: "gpt-4o-mini",
      messages,
      temperature: 0   // ← added: no hallucination
    })
  });

  const json = await res.json();
  return (
    json?.choices?.[0]?.message?.content ||
    "I couldn't find information about that in the policy documents."
  );
};